import BaseForm from '../base';
import { ObjectPanelComponent, LatLongColumnsComponent } from '../components';
export class SensorsForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent(),
            new ObjectPanelComponent({
                label: 'Points',
                key: 'points',
            }),
            new ObjectPanelComponent({
                label: 'SetPoints',
                key: 'setPoints',
            }),
        ];
    }
}
